import LegalLayout, { LegalBlock } from "./LegalLayout";
import { CONTACT } from "@/components/site/Reveal";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <LegalBlock heading="1. Introduction">
        <p>
          {CONTACT.company} ("we", "us", "our") is committed to protecting and respecting
          your privacy. This policy explains how we collect, use and safeguard the personal
          information you provide when you interact with our website and services.
        </p>
      </LegalBlock>
      <LegalBlock heading="2. Information We Collect">
        <p>
          We may collect your name, email address, phone number, company name and any
          details you submit through our contact form. We also collect standard technical
          data such as browser type and usage analytics to improve our services.
        </p>
      </LegalBlock>
      <LegalBlock heading="3. How We Use Your Information">
        <p>
          Your information is used to respond to enquiries, deliver our marketing and
          consulting services, and to communicate relevant updates. We do not sell your
          personal data to third parties.
        </p>
      </LegalBlock>
      <LegalBlock heading="4. Data Retention & Security">
        <p>
          We retain personal data only as long as necessary for the purposes described and
          apply appropriate technical and organisational measures to protect it against
          unauthorised access, loss or disclosure.
        </p>
      </LegalBlock>
      <LegalBlock heading="5. Your Rights">
        <p>
          Under UK GDPR you have the right to access, correct, or request deletion of your
          personal data, and to object to certain processing. To exercise these rights,
          contact us at {CONTACT.email}.
        </p>
      </LegalBlock>
      <LegalBlock heading="6. Contact">
        <p>
          For any privacy questions, contact {CONTACT.company} at {CONTACT.email} or
          {" "}{CONTACT.phone}. Registered address: {CONTACT.address}.
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
